"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var StyledInputText = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 25px;\n    background: ", ";\n\n    label {\n        font-weight: bold;\n        margin-bottom: 10px;\n    }\n"], ["\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 25px;\n    background: ", ";\n\n    label {\n        font-weight: bold;\n        margin-bottom: 10px;\n    }\n"])), function (props) { return (props.errored ? 'red' : 'transparent'); });
exports.default = StyledInputText;
var templateObject_1;
